<template>
  <t-content main>
    <c-zone-selection-info />
    <div class="zone-content">
      <t-container>
        <c-zone-announcement v-if="announcementId" :announcementId="announcementId" />
      </t-container>
      <c-loading-indicator :show="!show" />
      <template v-if="show">
        <template v-if="zones.length > 0">
          <m-zone-selection
            class="zone-selection"
            v-for="(zoneTeaserUi, idx) in zones"
            :key="`${zoneTeaserUi.zoneId}_${idx}`"
            :zone-teaser-ui="zoneTeaserUi"
          />
        </template>
        <p v-else>
          {{ $t('zoneSelection.main.tournaments_not_available') }}
        </p>
      </template>
    </div>
  </t-content>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'
import MZoneSelection from '@/modules/MZoneSelection.vue'
import CZoneSelectionInfo from '@/components/CZoneSelectionInfo.vue'
import CZoneAnnouncement from '@/components/CZoneAnnouncement.vue'
import { ERROR_CODES } from '@/model/ErrorCodes'
import { track } from '@/lib/track'

const router = useRouter()
const route = useRoute()
const store = useStore()
const show = ref(false)

const announcementId = computed(() => {
  return store.state.announcement
})

const zones = computed(() => {
  return store.getters.zoneTeasers
})

onMounted(() => {
  // make sure when the view is loaded that we reset the tournaments state
  // if not we will have problems with the MWinningDistribution.vue
  store.commit('resetActiveTournament')
  store
    .dispatch('fetchZoneTeasers')
    .then(() => {
      show.value = true
    })
    .catch((err: any) => {
      if (err && err.errorCode === 401) {
        router.replace('/extern/login')
      } else {
        console.log('huhu', err)

        router.push({ path: '/error/' + (err && err.errorCode) || ERROR_CODES.UNKNOWN + '' })
      }
    })
  track({
    id: 'zone-overview-enter',
    path: route.fullPath,
  })
})
</script>

<style lang="less" scoped>
@import '../styles/vars';
@import '~@npm/@gd/common-styles/lib/color-vars';
@import '~@npm/@gd/common-styles/lib/icf-fonts';

.zone-content {
  display: flex;
  position: relative;
  width: 100%;
  min-height: 18em;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.zone-selection {
  margin: 3em 0;
  &:first-of-type {
    margin-top: 6em;
  }
  &:last-of-type {
    margin-bottom: 6em;
  }
}
</style>
